// extracted by mini-css-extract-plugin
export default {"gridContainer":"CharacterGridContainer_gridContainer__ozJM2","grid":"CharacterGridContainer_grid__u+229","cell":"CharacterGridContainer_cell__JC52B"};